import AsyncStorage from "@react-native-async-storage/async-storage";
import { parseResponseBody } from "../services/apiClient";
const API_KEY = "930ea60ae8f417e2ee25e81f";
const LOCATION_DETAILS_KEY = "@locationDetails";
export type LocationDetails = {
  timezone: string;
  currency: string;
  country_name: string;
  currencyCode: string;
  currencyRate: number;
  country_code: string;
};

export const getUserLocationDetails =
  async (): Promise<LocationDetails | null> => {
    try {
      // 0. Check if we already have a cached location that’s not expired
      const cachedLocationJSON = await AsyncStorage.getItem(
        LOCATION_DETAILS_KEY
      );
      if (cachedLocationJSON) {
        const cachedLocation = JSON.parse(cachedLocationJSON);
        return cachedLocation;
      }

      // 1. Fetch IP-based location data (currency, timezone, etc.) in **ONE** request
      const ipApiResponse = await fetch(`https://ipapi.co/json/`);
      let ipApiData = await ipApiResponse.json();
      ipApiData = parseResponseBody(ipApiData);

      if (!ipApiData || !ipApiData.currency) {
        throw new Error("Failed to fetch currency details based on IP.");
      }

      const {
        currency: currencyCode,
        country_code,
        timezone,
        country_name,
      } = ipApiData;

      // 2. Fetch exchange rate for currencyCode vs. EUR
      const exchangeResponse = await fetch(
        `https://v6.exchangerate-api.com/v6/${API_KEY}/latest/GBP`
      );
      let exchangeData = await exchangeResponse.json();
      exchangeData = parseResponseBody(exchangeData);

      if (exchangeData.result !== "success") {
        throw new Error("Failed to fetch exchange rates.");
      }

      const currencyRate = exchangeData.conversion_rates?.[currencyCode];

      if (!currencyRate) {
        throw new Error(`Exchange rate for ${currencyCode} not available.`);
      }

      // 4. Construct the final location object
      const locationDetails: LocationDetails = {
        timezone: timezone || "Unknown Timezone",
        currency: currencyCode,
        country_name,
        currencyCode,
        currencyRate,
        country_code,
      };

      // 5. Store in AsyncStorage
      // Optional: add a timestamp if you want to expire the cache after a certain time
      // locationDetails.timestamp = Date.now();
      await AsyncStorage.setItem(
        LOCATION_DETAILS_KEY,
        JSON.stringify(locationDetails)
      );

      return locationDetails;
    } catch (error) {
      console.error("Error detecting location or fetching details:", error);
      return null;
    }
  };

// Example usage
(async () => {
  const locationDetails = await getUserLocationDetails();
  if (locationDetails) {
    console.log("Location details:", locationDetails);
    // ...
  } else {
    console.log("Failed to fetch location details.");
  }
})();
